import { getNonce, initTrustedTypes } from './_csp';
import { importPolyfills } from './_polyfills';

/** ES plugin. */
const esPlugin = {
  /** Init ES plugin. */
  init: () => {
    initTrustedTypes();
    importPolyfills();
  },

  /** CSP. */
  csp: {
    getNonce,
  },
};

export default esPlugin;
